import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index.vue";
import Book from "../views/book.vue";
import NotFound from "../views/not-found.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index
  },
  {
    path: "/book/:slug",
    name: "Book",
    component: Book
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
